<template>
  <div>
    <div class="bg-white rounded-md">
      <div v-if="isLoading">
        <Spinner />
      </div>
      <div v-else>
        <div class="Polaris-LegacyCard">
          <div class="Polaris-IndexTable">
            <div class="Polaris-IndexTable__IndexTableWrapper">
              <div class="Polaris-IndexTable__ScrollContainer">
                <table class="Polaris-IndexTable__Table">
                  <thead>
                    <tr>
                      <th
                        class="Polaris-IndexTable__TableHeading"
                        data-index-table-heading="true"
                      >
                        <div
                          style="--pc-index-table-heading-extra-padding-right:0"
                          class=""
                        >
                          <span
                            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                            >Customer</span
                          >
                        </div>
                      </th>
                      <th
                        class="Polaris-IndexTable__TableHeading"
                        data-index-table-heading="true"
                      >
                        <div
                          style="--pc-index-table-heading-extra-padding-right:0"
                          class=""
                        >
                          <span
                            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                            >Date</span
                          >
                        </div>
                      </th>
                      <th
                        class="Polaris-IndexTable__TableHeading"
                        data-index-table-heading="true"
                      >
                        <div
                          style="--pc-index-table-heading-extra-padding-right:0"
                          class=""
                        >
                          <span
                            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                            >Rating</span
                          >
                        </div>
                      </th>
                      <th
                        class="Polaris-IndexTable__TableHeading"
                        data-index-table-heading="true"
                      >
                        <div
                          style="--pc-index-table-heading-extra-padding-right:0"
                          class=""
                        >
                          <span
                            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                            >Comment</span
                          >
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(review, index) of reviews.docs"
                      :key="index"
                      class="Polaris-IndexTable__TableRow"
                    >
                      <td class="Polaris-IndexTable__TableCell">
                        <div class="flex items-center">
                          <img
                            :src="review.reviewer.profilePhotoUrl"
                            alt=""
                            referrerpolicy="no-referrer"
                            class="h-8 w-8 rounded-full mr-2"
                          />
                          <span
                            class="Polaris-Text--root Polaris-Text--bodyMd"
                            >{{ review.reviewer.displayName }}</span
                          >
                        </div>
                      </td>
                      <td class="Polaris-IndexTable__TableCell">
                        {{ review.createReviewTime | dateFilter }}
                      </td>
                      <td class="Polaris-IndexTable__TableCell">
                        <div class="flex">
                          <svg
                            v-for="i in review.starRating"
                            :key="i"
                            class="h-5 w-5 flex-shrink-0 text-yellow-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                      </td>
                      <td class="Polaris-IndexTable__TableCell">
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd"
                          style="    white-space: normal;"
                        >
                          {{ review.comment }}
                        </p>
                      </td>
                    </tr>
                    <tr
                      v-if="!reviews.docs || reviews.docs.length === 0"
                      class="Polaris-IndexTable__TableRow"
                    >
                      <td
                        colspan="4"
                        class="Polaris-IndexTable__TableCell text-center py-8"
                      >
                        <p
                          class="Polaris-Text--root Polaris-Text--bodyMd text-gray-500"
                        >
                          No reviews found. Please connect the google account to
                          sync your reviews
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Pagination
          :page="reviews"
          @pageChanged="loadPage"
          class="border border-gray-200"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import Pagination from "../Common/Pagination";
import Spinner from "vue-simple-spinner";

export default {
  name: "ReviewsList",

  data() {
    return {
      isLoading: false,
      reviews: {}
    };
  },
  components: {
    Pagination,
    Spinner
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  computed: {},
  created() {
    this.loadPage(1);
  },
  mounted() {},
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      const response = await this.$store.dispatch("getReviews", { page });
      this.reviews = response.reviews;

      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
